import { WorkerWithProfile } from './workforce.data'
import { ImageType } from "./files.model"
import { Entity, EntityBase } from "./entity.shared.data"
import { Ranking } from './events.data'
import { ColumnOrderType } from './settings.data'
export { Entity }

export type ExpandedEntity = Entity | WorkerWithProfile
export type EntityName = 'Sponsor' | 'Performer' | 'Exhibitor' | 'Workforce' | 'Exhibitor Stand' | 'Asset'  | 'Resource' | 'Cue' | 'Attendee'

export interface CreateEntityTemplatesData {
  type: ImageType
  entities: Entity[]
  accountId: string
  eventId?: string // optional for duplicating from table
  eventName?: string // optional for duplicating from table
}
export interface CreateEntitiesFromTemplatesData {
  type: ImageType
  ids: string[]
  accountId: string
  eventId: string
}

export type ClipLabel = '+ ADD TO CLIPBOARD' | 'SAVING...' | 'ADDED'
export type ClipboardTab = 'PERFORMERS' | 'EXHIBITORS' | 'SPONSORS' | 'ASSETS' | 'RESOURCES' | 'ATTENDEES'
export type EntitySubTable = 'contactDetails' | 'publish' | 'logistics' | 'myView' | 'responses' | 'attendees'
export const subTableNames: { [t in EntitySubTable]: string } = {
  contactDetails: 'CONTACT DETAILS', publish: 'PUBLISH', logistics: 'LOGISTICS', myView: 'MY VIEW', responses: 'RESPONSE TO QUESTIONS', attendees: 'ATTENDEES'
}
export type EntityConfigureSubpage = 'briefInfo' | 'customQuestions' | 'submissions'
export const entityConfigureSubpageNames: { [t in EntityConfigureSubpage]: string } = {
  briefInfo: 'BRIEF INFORMATION', customQuestions: 'CUSTOM QUESTIONS', submissions: 'SUBMISSIONS'
}

export const subTableIds: EntitySubTable[] = <EntitySubTable[]>Object.keys(subTableNames)
export const performerSubTableTypes: { [t in EntitySubTable]?: ColumnOrderType } = {
  myView: 'performersTable', contactDetails: 'performerContactsView', publish: 'performerPublishView', logistics: 'performerLogisticsView'
}
export const resourceSubTableTypes: { [t in EntitySubTable]?: ColumnOrderType } = {
  myView: 'resources', contactDetails: 'resourceContactsView', logistics: 'resourceLogisticsView'
}
export const exhibitorSubTableTypes: { [t in EntitySubTable]?: ColumnOrderType } = {
  myView: 'exhibitors', contactDetails: 'exhibitorContactsView', publish: 'exhibitorPublishView', logistics: 'exhibitorLogisticsView'
}
export const sessionSubTableTypes: { [t in EntitySubTable]?: ColumnOrderType } = {
  myView: 'performerSessionsTable', publish: 'sessionPublishView', logistics: 'sessionLogisticsView'
}


export interface EntityServiceFunctions {
  updateTypes: (types: Ranking[]) => Promise<void>
  updateEntities: (entities: EntityBase[]) => Promise<void>
}
